import React, { useState } from 'react';
import { SubscriptionPlans } from './SubscriptionPlans';
import { UpgradeModal } from './UpgradeModal';
import { useUpgradeFlow } from '../../hooks/useUpgradeFlow';
import { MembershipTier } from '../../types';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import toast from 'react-hot-toast';
import { Footer } from '../Footer';

export function SubscriptionPage() {
  const [selectedTier, setSelectedTier] = useState<MembershipTier | null>(null);
  const [selectedPrice, setSelectedPrice] = useState<number>(0);
  const [showModal, setShowModal] = useState(false);
  const { loading, upgradeTier } = useUpgradeFlow();
  const navigate = useNavigate();

  const handleSelectPlan = (tier: MembershipTier, price: number) => {
    setSelectedTier(tier);
    setSelectedPrice(price); // Price is already in cents
    setShowModal(true);
  };

  const handleConfirmUpgrade = async () => {
    if (!selectedTier) return;

    try {
      await upgradeTier(selectedTier, selectedPrice.toString());
      // Note: No need to navigate here as Stripe will handle the redirect
    } catch (error) {
      console.error('Error during upgrade:', error);
      toast.error('Failed to start upgrade process. Please try again.');
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-bw-surface-subtle">
      <div className="flex-grow">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
          <div className="mb-8">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center text-bw-muted hover:text-bw-ink"
            >
              <ArrowLeft className="h-5 w-5 mr-2" />
              Back
            </button>
          </div>
          
          <SubscriptionPlans onSelectPlan={handleSelectPlan} />
        </div>
      </div>

      <Footer />

      {showModal && selectedTier && (
        <UpgradeModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          selectedTier={selectedTier}
          price={selectedPrice / 100}
          onConfirm={handleConfirmUpgrade}
          loading={loading}
        />
      )}
    </div>
  );
}